import {svgIconWrapper} from '../svg-icon-wrapper';

import TagsRegularDiagonalReport from './tags-regular-diagonal-report-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <TagsRegularDiagonalReport {...props} />;
}
SvgComponent.iconName = 'tagsRegularDiagonalReport';

export const TagsRegularDiagonalReportIcon = svgIconWrapper(SvgComponent);
